import axios from "axios";

export const deletePermit = async (permitID: number) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API}/Permit/permit?PermitID=${permitID}`
    );
    return response;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
